// modules
// utils
import { get } from 'lodash'
import { createSelector } from 'reselect'

const patient = (state = {}) => get(state, ['patient'], {})

export const patientProfile$ = createSelector(patient, (patient = {}) =>
  get(patient, ['profile'], {})
)

export const patientProfileUuid$ = createSelector(
  patientProfile$,
  (profile = {}) => get(profile, ['uuid'], null)
)

export const patientDiseases$ = createSelector(patient, (patient = {}) =>
  get(patient, ['diseases'], [])
)

export const patientVitalGraph$ = createSelector(patient, (patient = {}) =>
  get(patient, ['vitalGraph'], {})
)
export const companySelector = (state) => state.company

export const companyReferenceTableSelector = createSelector(
  companySelector,
  (company) => company.references
)

export const eventTypes$ = createSelector(
  companyReferenceTableSelector,
  (refs) => refs?.eventTypes || []
)

export const patientActiveProgram$ = createSelector(patient, (patient = {}) =>
  get(patient, ['activeProgram', 'enrolledProgram'], {})
)

export const patientAllPrograms$ = createSelector(patient, (patient = {}) =>
  get(patient, ['allPrograms'], [])
)

export const patientAssignedMeasurement$ = createSelector(
  patient,
  (patient = []) => get(patient, ['assignedMeasurement'], [])
)

export const patientMeasurementActivityLog$ = createSelector(
  patient,
  (patient = []) => get(patient, ['measurementActivityLog'], [])
)

export const patientActivityLog$ = createSelector(patient, (patient = []) =>
  get(patient, ['activityLog'], [])
)

export const patientGoals$ = createSelector(patient, (patient = []) =>
  get(patient, ['goals'], [])
)

export const patientGoalInterventions$ = createSelector(
  patient,
  (patient = []) => get(patient, ['interventions'], [])
)

export const isAddPatientModalVisible$ = createSelector(
  patient,
  (patient = {}) => get(patient, ['isAddPatientModalVisible'], false)
)
